export const devHome = 'https://codexpert.io';